import React, { Component } from 'react'
import { connect } from 'react-redux'
import { navItemsConstant, widgetDisplayType } from '../../../config/layout2constant'
import PromoWidget from './promoWidget'
import { homeColor } from '../../JS/colorConfig'
import DoorKey from '../../../UI/doorKey/doorKey'
import { sendCommand } from '../../../action/roomControlAction'
import { setCurrentHomePage, setGoHome, setLoginRequired, setOpenExternalLinkInSameTab } from '../../action/homeAction'
import { setCurrentTabNavItemList } from '../../action/action'
import { currentWidget, setHcommerceSku, setPreCheckInWidgetState, setPreloadScreen, setRenderHomePage } from '../../../action/action'
import { setOpenCheckin, setOpenViewBill } from '../../action/homeAction'
import { Redirect, HashRouter, withRouter } from 'react-router-dom';
import { scrollToTop } from '../../../JS/scrollToTop';
import { DEMO, CHECKINENABLED, USEFRESHCHAT, FRESHCHATTOKEN, FRESHCHATHOST, HIDE_NUMBER_OF_DAYS, globalSalt, globalIV, CMSPath, commanEventListerKey } from '../../../config/constant'
import { setRegPage, setChatBubble } from '../../../action/action';
import moment from 'moment';
import Freshchat from 'react-freshchat';
import ChatBubble from '../chatWidget/chatBubble'
import SendSMSFloatingWidget from '../smsWidget/sendSMSFloatingWidget'
import { withTranslation } from 'react-i18next'
import { getServerTime, sendAnalytics } from '../../../action/homeAction'
import { AesUtil } from '../../../JS/AesUtil'
import checkPreCheckinWidgetState from './checkPreCheckInWidgetState'
import { toBool } from '../../JS/utility'
import PropTypes from 'prop-types';
import { floatingWidgetComp } from '../../../components/shared/mapNavItem'
import FloatingMiddleWidget from '../../../UI/widgetDisplayTypes/floatingMiddleWidget'
import { inAppBrowser } from '../../JS/inAppBrowser'

class HomePage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showSelectList: false,
            showSelected: 'Before arrival', //"Two days left in your stay",
            openCheckin:false,
            openViewBill:false,
            room:null,
            guestName: null,
            firstName: null,
            lastName: null,
            checkInWidgetType: checkPreCheckinWidgetState(this.props)
        }
        this.aesUtil = new AesUtil(128, 1000);
    }

    componentDidUpdate(preProp) {

        let room = localStorage.getItem("room");

        homeColor(this.props.menuColor);
        if(preProp.selectedHomePage !== this.props.selectedHomePage){
            scrollToTop();
        }

        if((preProp.preCheckInEnabled !== this.props.preCheckInEnabled || preProp.serverTimeDate !== this.props.serverTimeDate) && this.props.serverTimeDate){
            this.setState({checkInWidgetType: checkPreCheckinWidgetState(this.props)});
        }

        // It was causing maximum setState error and also not needed now
        // if(!this.props.storeSku && this.props.widgetList){
        //     console.log("setting sku")
        //     this.props.widgetList.map((item) => {

        //         for (let obj of item.widgets){
        //             if(obj.subWidgetMap[0] && obj.subWidgetMap[0].widgetType === "Hcommerce"){
        //                 let sku = obj.subWidgetMap[0].storeSku
        //                 this.props.setHcommerceSku(sku)
        //                 console.log("setting the state multiple times")
        //             }
        //         }
        //      })
        // }
    }

    showStatusHandler = (arr) => {

        // console.log("checked in guest",arr)
        const currentDate = moment.utc(this.props.serverTimeDate);
        const plannedCheckout = arr && arr[0] ? moment.utc(arr[0].plannedCheckOutDate) : null;
        let temp = this.props.selectedHomePage.uniqueKey;
        
        for(let obj of this.props.guestSteps){
        
            if (temp) {
                if (temp.replace(/ /g,'').toLowerCase() === 'explore') {

                    if (obj.key === "BA"){
                        return obj.value
                    }
                }
                else if (temp.replace(/ /g,'').toLowerCase() === 'mystay') {

                    if (obj.key === "IH"){
                        if(!plannedCheckout || HIDE_NUMBER_OF_DAYS){
                            return obj.value;
                        }else{
                            const diff = plannedCheckout.diff(currentDate, 'hours')
                            return Math.round(diff/24) <= 0 || !diff ? obj.value : (Math.round(diff/24) <= 1) ? `${Math.round(diff/24)} day left in your stay` :  `${Math.round(diff/24)} days left in your stay`;        
                        }
                    }
                }
                else if(temp.replace(/ /g,'').toLowerCase() === 'extratab1') {

                    if(obj.key == "ET1"){
                        return obj.value
                    }
                }
                else if(temp.replace(/ /g,'').toLowerCase() === 'extratab2') {

                    if(obj.key == "ET2"){
                        return obj.value
                    }
                }
            }
        }
        return this.props.selectedHomePage.tabName;
    }

    showSelectedList = () => {
        this.setState({ showSelectList: !this.state.showSelectList });
    }

    selectItem = (key) => {
        const { t } = this.props
        // Milind: GJ 2.0 APP issue Fixes - [Page 2] Menu items changed
 
        // this.setState({ showSelected: item, showSelectList: false })
        // this.onWidgetClick(widget)
        switch(key){
         case "BA":

                this.props.footerTabList.map((footerItem) => {
                    if (footerItem.tabName.replace(/ /g,'').toLowerCase() != this.props.selectedHomePage.tabName.replace(/ /g,'').toLowerCase() && footerItem.tabName.replace(/ /g,'').toLowerCase() === 'explore') {
                        
                        this.props.setCurrentHomePage(footerItem);
                        this.props.widgetList.map((item) => {
                            if (item.uniqueKey === footerItem.tabName.replace(/ /g,'').toLowerCase() && item.uniqueKey === 'explore') {
                                this.props.setCurrentTabNavItemList();
                                this.props.setCurrentTabNavItemList(item.widgets);
                            }
                        })
                    }
                })
                this.showSelectedList();
             break;
         case "CI":
             if(CHECKINENABLED){
                 let checkinWidgetInfo

                 // Getting mobile checkin widget info from the widget list
                this.props.widgetList.map((item) => {
                    console.log("widget item", item)
                    item.widgets.map(subItem => {
                        subItem.subWidgetMap.map(widget => {
                            if(widget.widgetType == "Mobile Check-in"){
                                checkinWidgetInfo = widget
                            }
                        })
                    })
                    return 0
                })
                checkinWidgetInfo ? this.props.currentWidget(checkinWidgetInfo) 
                : this.props.currentWidget({widgetType: "Mobile Check-in", widgetName: "Checkin"}); 
                this.setState({openCheckin:true});
             }
             this.setState({showSelectList:false});
             break;
        case "PCI":
            if(CHECKINENABLED){
                let checkinWidgetInfo

                // Getting mobile checkin widget info from the widget list
               this.props.widgetList.map((item) => {
                   console.log("widget item", item)
                   item.widgets.map(subItem => {
                       subItem.subWidgetMap.map(widget => {
                           if(widget.widgetType == "Pre Check-in" || widget.widgetType == "Mobile Check-in"){
                               checkinWidgetInfo = widget

                               if(this.state.checkInWidgetType == "mobile check-in"){
                                    checkinWidgetInfo.widgetTitle = t('check_in.checkin_widget_name')
                                    checkinWidgetInfo.widgetType = "Mobile Check-in"
                                    
                                } else if (this.state.checkInWidgetType == "early check-in"){
                                    checkinWidgetInfo.widgetTitle = t('check_in.early_checkin_widget_name')
                                    checkinWidgetInfo.widgetType = "Mobile Check-in"
                                } else if (this.state.checkInWidgetType == "pre check-in"){
                                    checkinWidgetInfo.widgetTitle = t('pre_checkIn.pre_checkin_widget_name')
                                    checkinWidgetInfo.widgetType = "Pre Check-in"
                                }
                           }
                       })
                   })
                   return 0
               })
               checkinWidgetInfo ? this.props.currentWidget(checkinWidgetInfo) 
               : this.props.currentWidget({widgetType: "Pre Check-in", widgetName: "Pre Check-in"}); 
               this.setState({openCheckin:true});
            }
            this.setState({showSelectList:false});
            break;
         case "IH":
            // if (homeNaviation.length > 1) {
             //    this.props.setCurrentHomePage(homeNaviation[1]);
            // }
                    this.props.footerTabList.map((footerItem) => {
                        if (footerItem.tabName.replace(/ /g,'').toLowerCase() != this.props.selectedHomePage.tabName.replace(/ /g,'').toLowerCase() && footerItem.tabName.replace(/ /g,'').toLowerCase() === 'mystay') {
                            
                            this.props.setCurrentHomePage(footerItem);
                            this.props.widgetList.map((item) => {
                                if (item.uniqueKey === footerItem.tabName.replace(/ /g,'').toLowerCase() && item.uniqueKey === 'mystay') {
                                    this.props.setCurrentTabNavItemList();
                                    this.props.setCurrentTabNavItemList(item.widgets);
                                }
                            })
                        }
                    })

                this.showSelectedList();

             break;
         case "CO":
            let checkoutWidgetInfo = null
            const room = localStorage.getItem("room");
             this.props.widgetList.map((item) => {
                console.log("widget item", item)
                    item.widgets.map(subItem => {
                        subItem.subWidgetMap.map(widget => {
                            if(widget.widgetType == "View Bill"){
                                checkoutWidgetInfo = widget
                            }
                        })
                    })
                    return 0
             })

            //  console.log("view bill widget",widget)

             if(checkoutWidgetInfo){
                 if(!room || room === "null"){
                    if(process.env.REACT_APP_INROOMTAB == "true") {
                        this.props.setLoginRequired(true)
                    } else {
                        this.props.setRegPage(true);
                    }
                 }else{
                    this.setState({openViewBill:true});
                    this.props.currentWidget(checkoutWidgetInfo)
                 }
             }

             this.setState({showSelectList:false})

             break;
             case "ET1":
                    this.props.footerTabList.map((footerItem) => {
                        if (footerItem.tabName.replace(/ /g,'').toLowerCase() != this.props.selectedHomePage.tabName.replace(/ /g,'').toLowerCase() && footerItem.uniqueKey.replace(/ /g,'').toLowerCase() === 'extratab1') {
                            
                            this.props.setCurrentHomePage(footerItem);
                            this.props.widgetList.map((item) => {
                                if (item.uniqueKey.replace(/ /g,'').toLowerCase() === footerItem.uniqueKey.replace(/ /g,'').toLowerCase() && item.uniqueKey.toLowerCase() === 'extratab1') {
                                    this.props.setCurrentTabNavItemList();
                                    this.props.setCurrentTabNavItemList(item.widgets);
                                }
                            })
                        }
                    })

                this.showSelectedList();

             break;
             case "ET2":
                this.props.footerTabList.map((footerItem) => {
                    if (footerItem.tabName.replace(/ /g,'').toLowerCase() != this.props.selectedHomePage.tabName.replace(/ /g,'').toLowerCase() && footerItem.uniqueKey.replace(/ /g,'').toLowerCase() === 'extratab2') {
                        
                        this.props.setCurrentHomePage(footerItem);
                        this.props.widgetList.map((item) => {
                            if (item.uniqueKey.replace(/ /g,'').toLowerCase() === footerItem.uniqueKey.replace(/ /g,'').toLowerCase() && item.uniqueKey.toLowerCase() === 'extratab2') {
                                this.props.setCurrentTabNavItemList();
                                this.props.setCurrentTabNavItemList(item.widgets);
                            }
                        })
                    }
                })

            this.showSelectedList();
         break;
         default:
             console.log("invalid key");
         }
 
     }

     getLine1 = () => {
        let roomNum = localStorage.getItem("room")

        if (!roomNum || roomNum === "null") {
            if (this.props.profile.greetingsLine1) {
                let line1 = this.props.profile.greetingsLine1.trim()
                    return line1;
                }
        } else {
            if (this.props.profile.greetingsLine3) {
                let line1 = this.props.profile.greetingsLine3.trim()
                if(this.props.guestNameProps){
                    return `${line1} ${this.props.guestNameProps},`
                } else {
                    return line1
                }
            }
        }
    }

    getLine2 = () => {
        let roomNum = localStorage.getItem("room")
        console.log('this.props.profile.greetingsLine1',this.props.profile.greetingsLine1)

        if (!roomNum || roomNum === "null") {
            if (this.props.profile.greetingsLine4 && typeof this.props.profile.greetingsLine4 === "string") {
                let line2 = this.props.profile.greetingsLine4.trim();
                return line2;
            }
        }
        else {
            if (this.props.profile.greetingsLine2 && typeof this.props.profile.greetingsLine2 === "string") {
                let line4 = this.props.profile.greetingsLine2.trim();
                if (line4.indexOf("#GUEST_NAME#") !== -1 && this.props.guestNameProps) {
                    return line4.replace("#GUEST_NAME#", this.props.guestNameProps);
                } else if (line4.indexOf("#ROOM#") !== -1) {
                    if (roomNum && roomNum !== "null") {
                        return line4.replace("#ROOM#", roomNum);
                    } else {
                        line4 = null
                    }
                }
                else {
                    return line4
                }
            }
        }
    }

    shouldShowWidget_ForTheKnow(subWidget){
  
        if(subWidget.widgetTypeName=="The Know(Join The Know)")
            return !this.props.externalSignIn.memberId
        else if (subWidget.widgetTypeName=="The Know(Already Joined)")
            return this.props.externalSignIn.memberId      
    }   


    handleMessageEventLister = (event) => {

        console.log("handleMessageEventLister: ", event);
        try {
            const message = event;
            const freshData = this.props.freshChatData;
            if (message && message.data.type === "INNSPIRE_GO_HOME") {
              this.props.setGoHome(true)
              return;
            }

            if (message.data && message.data.type == "INNSPIRE_ROUTE_TO") {
                const { url, metaData={}, app_route } = message.data.payload;

                if (app_route) {
                    this.props.currentWidget({ widgetType: "RANDOM WIDGET TYPE", targetUrl: url, ...metaData });
                    this.props.history.push(app_route);
                }

                return;
            }

            if(message.data && message.data.type == "INNSPIRE_SAVE_DATA"){

                const toBeStoredDataKey = message.data.payload.key;
                const toBeStoredData = message.data.payload.value;

                localStorage.setItem(toBeStoredDataKey, toBeStoredData)
                return;
            }


            if (message.data && message.data.type === "INNSPIRE_GET_DATA") {
                const dataKeys = message.data.payload.key || [];
                const responseData = {};
             
                dataKeys.forEach((key) => {
                    const storedData = localStorage.getItem(key);
                    if(storedData) responseData[key] = storedData;
                });
                responseData.trip_planner_data = JSON.stringify({
                    "csslink":(freshData && freshData.login && freshData.login.innspireTPStyle) ||
                    (freshData && freshData.logout && freshData.logout.innspireTPStyle) || null
                })
                
                console.log("Response data is here")
                console.log(responseData);
              
                const iframes = document.getElementsByTagName('iframe');

                Array.from(iframes).forEach((iframe) => {
                    if (iframe.src && iframe.src.includes(message.origin)) {
                        console.log("Pushing to iframe")
                        iframe.contentWindow.postMessage({
                            type: "INNSPIRE_DATA_TO_IFRAME",
                            payload: responseData
                        }, "*");
                    }
                });
                console.log("Response data is here",responseData)
                console.log(responseData);
                return;
            }


            if(message.data && message.data.type == "INNSPIRE_OPEN_URL"){

                const targetUrl = message.data.payload && message.data.payload.url;
                const target = message.data.payload.target;

                inAppBrowser(targetUrl, this.props, false, {
                    widgetType: "Url Renderer",
                    meta: {
                        loadInExternalBrowser: target === "_system",
                        dontSetCurrentWidget: true
                    }
                });

                return;
            }

          } catch (error) {
            console.error("Error handling homepage message eventlistener:", error);
          }
    }

    componentDidMount(){
        const room = localStorage.getItem("room") && localStorage.getItem("room") !== 'null' ? true : false;
        this.setState({room:room});
        scrollToTop();


        setTimeout(() => {
            if (!window[commanEventListerKey]) {
              window.addEventListener("message", this.handleMessageEventLister);
              window[commanEventListerKey] = true;
            }
          }, 0);
    }

    componentWillUnmount() {
        
        window.removeEventListener("message", this.handleMessageEventLister);
        if (window[commanEventListerKey]) {
          window[commanEventListerKey] = false;
        }
      }

    render() {
        const {freshChatData} = this.props;
        // console.log("this.props.widgetList",this.props.widgetList);
        const { t } = this.props
        let greetingLine1 = this.getLine1()
        let greetingLine2 = this.getLine2()
        let isGuestLogin = !localStorage.getItem('room') || localStorage.getItem('room') == 'null'


        return this.props.renderHomePage && (
            <div>{console.log('this.props.widgetList',this.props.widgetList)}
                <section id="landingPage" className={`widgets ${this.props.selectedHomePage.uniqueKey}`}>

                <div class="image-heading">

                    <div class="img-banner">
                        <img src={`${CMSPath}${this.props.bgImage}`} />
                    </div>

                    <div class="heading" id = "heading" style = {{transition:"0.2s",color:this.props.menuColor.assetFontSelectorColor}}>
                        <h1>{this.props.PageNameFromParent ? this.props.PageNameFromParent :
                            this.props.selectedHomePage && this.props.selectedHomePage.tabName ?
                                this.props.selectedHomePage.tabName : ""}
                        </h1>
                        {!isGuestLogin && <p class="bold" onClick={() => isGuestLogin ? process.env.REACT_APP_INROOMTAB != "true" && this.props.setRegPage(true) : null}>
                            {this.props.GreetingFromParent ? this.props.GreetingFromParent : greetingLine1}
                        </p>}
                        <p >{greetingLine2}</p>
                    </div>
                    
                </div>

                    <div className="widgets user-info dropdown">
                        <div className="user-login tile tile-container" style={{ display: "none" }}>
                            <div className="label">Login</div>
                            <div className="social-media-icons">
                                <a href="javascript:void(0)" className="smi-g"></a>
                                <a href="javascript:void(0)" className="smi-t"></a>
                                <a href="javascript:void(0)" className="smi-f"></a>
                            </div>
                        </div>
                    </div>

                    { this.props.serverTimeDate &&    

                        // Milind: GJ 2.0 APP issue Fixes - [Page 2] Menu items changed
                        <div className="user-stay tile tile-container custom-select" style = {{
                            backgroundColor:this.props.menuColor.assetBackgroundSelectorColor
                        }}>
                            <div className="select-selected" onClick={this.showSelectedList}
                                style={{ backgroundColor: "inherit" }}>
                                {this.showStatusHandler(this.props.CheckedInGuest)}
                            </div>
                            <div className={`select-items ${this.state.showSelectList ? "" : "select-hide"}`}>

                            {/* Milind: GJ 2.0 APP issue Fixes - [Page 2] Menu items changed */}
                            {this.props.guestSteps.map((el,index) => {

                                if(localStorage.getItem("room") && localStorage.getItem("room") != "null"){
                                    if(el.key == 'CI' || el.key == "PCI"){
                                        return null;
                                    }
                                }

                                if(el.key == "PCI"){

                                    if(this.state.checkInWidgetType == "mobile check-in"){
                                        el.value = t('check_in.checkin_widget_name');
                                    } else if (this.state.checkInWidgetType == "early check-in"){
                                        el.value = t('check_in.early_checkin_widget_name');
                                    } else if (this.state.checkInWidgetType == "pre check-in") {
                                        el.value = t('pre_checkIn.pre_checkin_widget_name');
                                    }
                                }

                                return(<div key = {el.key} onClick={() => this.selectItem(el.key)}>{el.value}</div>)
                            })}
                            </div>
                        </div>
                    }


                    {
                        this.props.promoWidgets && this.props.promoWidgets.length > 0 ?
                            <PromoWidget promoWidgets={this.props.promoWidgets} />
                            : null
                    }
                    {console.log("this.props.currentWidgetList",this.props.currentWidgetList)}
                    <div class="widgets body-widgets" >
                    { this.props.serverTimeDate && 

                this.props.currentWidgetList.map((iterator, index) => {


                            // dont show TheKnow widgets... dependent on the if the know memberId is present or not
                            if(iterator.subWidgetMap && iterator.subWidgetMap.some((subWidget)=>subWidget.widgetTypeName=="The Know(Join The Know)" || subWidget.widgetTypeName=="The Know(Already Joined)" )){
                                const updatedSubWidgetMap= [];

                                for(let subWidget of iterator.subWidgetMap){
                                        if(this.shouldShowWidget_ForTheKnow(subWidget))
                                            updatedSubWidgetMap.push(subWidget);
                                }

                                if(!updatedSubWidgetMap.length)
                                    return;
                                
                                iterator.subWidgetMap =  updatedSubWidgetMap;
                            }

                        
                            const isGuestItinerary =  iterator.subWidgetMap.find((obj) => obj.widgetType == "Guest Itinerary");
                            const isWeather =  iterator.subWidgetMap.find((obj) => obj.widgetType == "Weather");
                            const isHomescreenIframe =  iterator.subWidgetMap.find((obj) => obj.widgetType == "URL iFrame Renderer (Open Default)");
                            const isTripPlanner =  iterator.subWidgetMap.find((obj) => obj.widgetType == "Trip Planner (Open default)");
                            const isClock =  iterator.subWidgetMap.find((obj) => obj.widgetType == "Clock");
                            const isMultiController =  iterator.subWidgetMap.find((obj) => obj.widgetType == "Multi Controller - Room Wise (Open Default)");

                            if(isGuestItinerary){
                                iterator.widgetType = "Guest Itinerary";
                            }

                            if(isWeather){
                                iterator.widgetType = "Weather";
                            }

                            if(isClock){
                                iterator.widgetType = "Clock";
                            }

                            if(isHomescreenIframe){
                                iterator.widgetType = "URL iFrame Renderer (Open Default)";
                            }

                            if(isTripPlanner){
                                iterator.widgetType = "Trip Planner (Open default)";
                            }
                            
                            if(isMultiController){
                                iterator.widgetType = "Multi Controller - Room Wise (Open Default)";
                            }

                            return widgetDisplayType.map((displaytype) => {
                                let WidgetDisplayComponent = displaytype.CompName
                                if (displaytype.type === iterator.widgetType) {

                                    let subWidgetMap = iterator.subWidgetMap;
                                    const component = <WidgetDisplayComponent parentWidget={iterator} widgetList={subWidgetMap} />

                                    const configurePreCheckinWidget = (subwidgetIndex) => {
                                        
                                        if(this.state.checkInWidgetType == "mobile check-in"){
                                            subWidgetMap[subwidgetIndex].widgetTitle = t('check_in.checkin_widget_name')
                                            subWidgetMap[subwidgetIndex].widgetType = "Mobile Check-in"
                                        } else if (this.state.checkInWidgetType == "early check-in"){
                                            subWidgetMap[subwidgetIndex].widgetTitle = t('check_in.early_checkin_widget_name')
                                            subWidgetMap[subwidgetIndex].widgetType = "Mobile Check-in"
                                        } else if (this.state.checkInWidgetType == "pre check-in"){
                                            subWidgetMap[subwidgetIndex].widgetTitle = t('pre_checkIn.pre_checkin_widget_name')
                                            subWidgetMap[subwidgetIndex].widgetType = "Pre Check-in"
                                        }
                                        return component
                                    }

                                    const mobileCheckInIndex = iterator.subWidgetMap.findIndex((obj) => obj.widgetType === "Mobile Check-in");
                                    const preCheckInIndex = iterator.subWidgetMap.findIndex((obj) => obj.widgetType === "Pre Check-in");
                                    const guestDetailsIndex = iterator.subWidgetMap.findIndex((obj) => obj.widgetType == "Guest Details")
                                    // const hotelSelector = iterator.subWidgetMap.findIndex((obj) => obj.widgetType == "Hotel Selector")

                                    const tvLiftIndex = iterator.subWidgetMap.findIndex((obj) => obj.widgetType == "TV Lift Control");
                                    
                                    if (mobileCheckInIndex !== -1) {
                                        return !this.state.room || this.state.room === "null" ? configurePreCheckinWidget(mobileCheckInIndex) : null;
                                    } else if (preCheckInIndex !== -1) {
                                        return !this.state.room || this.state.room === "null" ? configurePreCheckinWidget(preCheckInIndex) : null;
                                    } 
                                    // else if (hotelSelector != -1) {
                                    //     return !this.state.room || this.state.room === "null" ? component : null;
                                    // }
                                     else if (guestDetailsIndex !== -1){

                                        let roomNumber = (localStorage.getItem("room") && localStorage.getItem("room") != "null") ? localStorage.getItem("room") : ""


                                        subWidgetMap[guestDetailsIndex].widgetTitle_default = subWidgetMap[guestDetailsIndex].widgetTitle_default || subWidgetMap[guestDetailsIndex].widgetTitle
                                        subWidgetMap[guestDetailsIndex].widgetDesc_default = subWidgetMap[guestDetailsIndex].widgetDesc_default || subWidgetMap[guestDetailsIndex].widgetDesc
                                        subWidgetMap[guestDetailsIndex].buttonTitle_default = subWidgetMap[guestDetailsIndex].buttonTitle_default || subWidgetMap[guestDetailsIndex].buttonTitle


                                        if((this.props.loginGuestDetails || localStorage.getItem("Set_Current_Logged_In_Guest_Details"))){

                                            const checkInguestInfo = this.props.loginGuestDetails ? this.props.loginGuestDetails : JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"));

                                            const guestName = checkInguestInfo[0].guestName || "";
                                            const firstName = checkInguestInfo[0].guestProfile.firstName || "";
                                            const lastName = checkInguestInfo[0].guestProfile.lastName || "";

                                            subWidgetMap[guestDetailsIndex].widgetTitle = subWidgetMap[guestDetailsIndex].widgetTitle_default.replace("#MESSAGEFROMAPP", t('guest_details.widget_title_logged_in')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace("#ROOMNUMBER", roomNumber)
                                            subWidgetMap[guestDetailsIndex].widgetDesc = subWidgetMap[guestDetailsIndex].widgetDesc_default.replace("#MESSAGEFROMAPP", t('guest_details.widget_description_logged_in')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace("#ROOMNUMBER", roomNumber)
                                            subWidgetMap[guestDetailsIndex].buttonTitle = subWidgetMap[guestDetailsIndex].buttonTitle_default.replace("#MESSAGEFROMAPP", t('guest_details.widget_button_title_logged_in')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace("#ROOMNUMBER", roomNumber)
                                        }
                                        
                                        else if(localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) {
 
                                            const preCheckInDetails= JSON.parse(this.aesUtil.decrypt(globalSalt, globalIV, "1234567891234567",localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")))
                                            
                                            const guestName =  preCheckInDetails.guestName || "";
                                            const firstName = preCheckInDetails.firstName || "";
                                            const lastName = preCheckInDetails.lastName || "";
                                            
    
                                            subWidgetMap[guestDetailsIndex].widgetTitle = subWidgetMap[guestDetailsIndex].widgetTitle_default.replace("#MESSAGEFROMAPP", t('guest_details.widget_title_pre_checked_in')).replace("#GUESTNAME", guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace("#ROOMNUMBER", roomNumber)
                                            subWidgetMap[guestDetailsIndex].widgetDesc = subWidgetMap[guestDetailsIndex].widgetDesc_default.replace("#MESSAGEFROMAPP", t('guest_details.widget_description_pre_checked_in')).replace("#GUESTNAME",  guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace("#ROOMNUMBER", roomNumber)
                                            subWidgetMap[guestDetailsIndex].buttonTitle = subWidgetMap[guestDetailsIndex].buttonTitle_default.replace("#MESSAGEFROMAPP", t('guest_details.widget_button_title_pre_checked_in')).replace("#GUESTNAME",  guestName).replace("#FIRSTNAME", firstName).replace("#LASTNAME", lastName).replace("#ROOMNUMBER", roomNumber)
                                        }

                                        else {
                                            subWidgetMap[guestDetailsIndex].widgetTitle = subWidgetMap[guestDetailsIndex].widgetTitle_default.replace("#MESSAGEFROMAPP", t('guest_details.widget_title_logged_out'))
                                            subWidgetMap[guestDetailsIndex].widgetDesc = subWidgetMap[guestDetailsIndex].widgetDesc_default.replace("#MESSAGEFROMAPP", t('guest_details.widget_description_logged_out'))
                                            subWidgetMap[guestDetailsIndex].buttonTitle = subWidgetMap[guestDetailsIndex].buttonTitle_default.replace("#MESSAGEFROMAPP", t('guest_details.widget_button_title_logged_out'))
                                        }


                                        if(this.props.preCheckInBookingDueIn){
                                            subWidgetMap[guestDetailsIndex].path = `/checkin/id?widgetType=${this.state.checkInWidgetType}`
                                        } else{
                                            subWidgetMap[guestDetailsIndex].path = ""
                                        }

                                        return component;
                                    }

                                    else if(tvLiftIndex !== -1) {
                                        return this.props.showTVLiftWidget ? component : null
                                    }
                                    
                                    else {
                                        return component;
                                    }
                                    
                                }
                            })
                        })
                    }</div>
                    { this.props.floatingWidgetRenderType == "BOTTOM_DOCKED" ? 

                    <div className='doorkey multi-button'>
                        {(() => {
                            let chatWidget = null;
                            let normalFloatingWidget = [];
                            let doorKeyWidget = null;

                            this.props.floatingWidgets.forEach((iterator) => {
                                if (iterator.widgetTypeName === 'Chat') {
                                    chatWidget = <ChatBubble widgetInfo={iterator} />;
                                } else if (iterator.widgetTypeName === "SMS Message") {
                                    chatWidget = <SendSMSFloatingWidget widgetInfo={iterator} />;
                                }

                                if(iterator.widgetTypeName != "Chat" && iterator.widgetTypeName != "SMS Message" && iterator.widgetTypeName != "Digital Door Key"){

                                    let widgetInfo = floatingWidgetComp(this.props, iterator, navItemsConstant)
                                    normalFloatingWidget.push(<FloatingMiddleWidget widgetList={widgetInfo[0].subWidgetMap} />)
                                }
                                
                                if (iterator.widgetTypeName === 'Digital Door Key') {
                                    doorKeyWidget = <DoorKey widgetInfo={iterator} />;
                                }
                            });

                            return (
                                <>
                                    {chatWidget}
                                    {normalFloatingWidget.map((middleWidgets) => {return middleWidgets})}
                                    {doorKeyWidget}
                                </>
                            );
                        })()}
                    </div>
                    
                    : this.props.floatingWidgets.map((iterator, index) => {
                        // Milind: 
                        // Iterate through floating widets and show/hide Door Key button.
                            if (iterator.widgetTypeName === 'Digital Door Key') {
                                return (<DoorKey widgetInfo={iterator} />)
                            }
                            if (iterator.widgetTypeName === 'Chat') { // && (!this.state.room || this.state.room == 'null')
                                return ( this.props.chatWidgetInnitialized && <ChatBubble widgetInfo={iterator}/>)
                            } else if(iterator.widgetTypeName == "SMS Message") {
                                return (<SendSMSFloatingWidget widgetInfo={iterator} />)
                            }
                        })
                    }

                    {<div class="row app-version">
                        <p class="margin-bottom-0" style={{fontSize:'0.8rem'}}>{`V${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`}</p>
                    </div>}

                    { console.log('this.props.opeDemoCamera',this.props.openDemoCamera, this.state.room) }
                    {
                        this.props.openDemoCamera ? <HashRouter>
                            <Redirect exact to="/roomControl/demoDoorCamera" />
                        </HashRouter>:null
                    }            
                    {
                        this.state.openCheckin ?<HashRouter>
                            <Redirect exact to ="/checkin/id"/>
                        </HashRouter> : null
                    }
                    {
                        this.state.openViewBill ?<HashRouter>
                        <Redirect exact to ="/viewBill2"/>
                    </HashRouter> : null
                    }
                    {/* {console.log('this.props.isMobileTV',this.props.isMobileTV)} */}
                    {
                        this.props.isMobileTV ?<HashRouter>
                        <Redirect exact to ="/mobileTV"/>
                    </HashRouter> : null
                    }
                    
                </section>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        profile: state.store.home.currentDuration.brandingInfo.app ?
            state.store.home.currentDuration.brandingInfo.app.profileWidget : {},
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        navList: state.store.sideNavBar.navItems,
        showTVLiftWidget: state.store.showTVLiftWidget,
        bgImage: state.store.home.currentDuration.launcherBgImageUrl,
        guestNameProps: state.store.home.guestDetails ?
            state.store.home.guestDetails.guestName : null,
        menuColor: state.store.home.MenuColor,
        CheckedInGuest: state.store.CheckedInGuest,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        guestDetail: state.store.home.guestDetails,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        isMobileTV: state.store.home.isMobileTV,
        promoWidgets: state.store.home.currentDuration.bigWidgets ?
            getWidgetSelector(state) : [],
        exploreItems: state.store2.sideNavBar.exploreItems,
        openDemoCamera: state.store2.openDemoCamera,
        currentWidgetList: state.store2.sideNavBar.currentWidgetList,
        floatingWidgets: state.store.home.currentDuration.floatingWidgets ?
            state.store.home.currentDuration.floatingWidgets : [],
        floatingWidgetRenderType : state.store.home.currentDuration.floatingWidgetRenderType ? state.store.home.currentDuration.floatingWidgetRenderType : null,
        VDAZoneList: state.store.roomControl.VDAZoneList,
        selectedHomePage: state.store2.currentHomePage,
        guestSteps : state.store.home.guestStepsDropDownOptions,
        freshChatData: state.store.freshChatData,
        widgetList: state.store2.sideNavBar.widgetList,
        footerTabList: getTabs(state.store.home.currentDuration),
        serverTimeDate: state.store.home.serverTimeDate.date,
        mobileCheckInDisabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.mobileCheckInDisabled) : false,
        preCheckInEnabled: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled ? toBool(state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.preCheckInEnabled) : false,
        checkInStartTime: state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.checkInStartTime,
        earlyCheckInStartTime:  state.store.home.clientConfig.webAppWidgetsInfo && state.store.home.clientConfig.webAppWidgetsInfo.mobileCheckInConfigs.earlyCheckInStartTime,
        checkPreCheckInWidgetState: state.store2.checkPreCheckInWidgetState,
        renderHomePage: state.store2.renderHomePage,
        preCheckInBookingDueIn: state.store2.preCheckInBookingDueIn,
        loginGuestDetails: state.store2.loginGuestDetails,
        chatWidgetInnitialized: state.store2.chatWidgetInnitialized,
        externalSignIn: state.store2.externalSignIn,

    }
}

const getTabs = (duration) => {
    if (duration && duration.tabDetails && duration.tabDetails.length > 0) {
        return duration.tabDetails
    } else { return false }
}

const getWidgetSelector = (state) => {

    var widgets = [];

    state.store.home.currentDuration.bigWidgets.map((obj) => {
        if (state.store2.currentHomePage.tabName) {
            if (obj.uniqueKey === state.store2.currentHomePage.uniqueKey
                || obj.uniqueKey === state.store2.currentHomePage.tabName.replace(/ /g,'').toLowerCase()) {
                widgets = obj.widgets
            }   
        }
    })
    console.log('getWidgetSs',widgets)
    return widgets
};


HomePage.propTypes = {
    PageNameFromParent: PropTypes.string,
    GreetingFromParent: PropTypes.string
}

HomePage.defaultProps = {
    PageNameFromParent: "",
    GreetingFromParent: ""
}

export default connect(
    mapStateToProps,
    {
        sendAnalytics,
        currentWidget,
        setCurrentHomePage,
        sendCommand,
        setLoginRequired,
        setRenderHomePage,
        setCurrentTabNavItemList,
        setOpenCheckin,
        setOpenViewBill,
        setPreCheckInWidgetState,
        setRegPage,
        setGoHome,
        setOpenExternalLinkInSameTab,
        setChatBubble,
        getServerTime,
        setHcommerceSku
    }
)(withTranslation('translations')(withRouter(HomePage)));